import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import com_logo from "../Home/Home_modules/Im/com_logo.png";
import { getAuth } from "firebase/auth";

class Mobile_User_Menu extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            notifications: [],
            notificationCount : '',
        }
        this.menuPopup = this.menuPopup.bind(this);
        this.menuClose = this.menuClose.bind(this);
        this.notificationPopupOpen = this.notificationPopup.bind(this);
        this.notificationPopupClose = this.notificationClose.bind(this);
        this.notificationsRead = this.notificationsRead.bind(this);
    }
    menuPopup(){
        document.querySelector('.mobile-menu-popup').classList.add('mobile-menu-popup-active')
    }
    menuClose(){
        document.querySelector('.mobile-menu-popup').classList.remove('mobile-menu-popup-active')
    }
    notificationPopup(){
        document.querySelector('.notification-container').classList.add('notification-container-active')
    }
    notificationClose(){
        document.querySelector('.notification-container').classList.remove('notification-container-active')
    }
    notificationsRead(notificationId){
        document.getElementById(notificationId).style.opacity = 0.5;
        const notificationReadAPI = 'https://us-central1-diginoor-3755e.cloudfunctions.net/app/notifications/update'
        fetch(notificationReadAPI,
        {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
            body: JSON.stringify({
                id: notificationId,
            })
        })
        .then(res => res.json())
        .then(data => {
            console.log(data)
        }
        )
        .catch(err => console.log(err))
    }
    componentDidMount(){
        const userUid = getAuth().currentUser.uid;
        const notificationUrl = `https://us-central1-diginoor-3755e.cloudfunctions.net/app/notifications/user/?uid=${userUid}`;
        fetch(notificationUrl,
            {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Origin': '*',

                }   
            })
        .then(res => res.json())
        .then(data => {
           // console.log(data);
            this.setState({notifications: data.notifications})
            const length = data.notifications.filter(function(item){
                return item.read == false;
              }).length;
              
            this.setState({notificationCount: length})
        }
        )
        .catch(err => console.log(err))
    }

    render(){
        return(
            <>
                <div className="mobile-menu-container">
                    <div>
                    <Link to="/"><img className="mobile-com-logo" src={com_logo} alt="Logo" /></Link>
                    </div>
                    <div className="mobile-menu-content">
                    <Link to="/wallet"><i class='fas fa-wallet' ></i></Link>
                    <button onClick={this.notificationPopup} className='notification-bell'>
                        <i class="fas fa-bell"></i>
                        <span className='notification-count'>{this.state.notificationCount}</span>
                        </button>
                    <button onClick={this.menuPopup} className="menu-bt-icon"><i class="fas fa-bars"></i></button>
                    </div>
                </div>

                {/* Mobile Menu Popup */}
                <div className="mobile-menu-popup">
                    <div className="mobile-menu-popup-content">
                        <div className="mobile-menu-popup-content-header">
                            <h3>English</h3>
                            <button onClick={this.menuClose} className="menu-popup-close">X</button>
                        </div>
                        <div className="mobile-menu-popup-content-body">
                            <ul>
                                <li><Link onClick={this.menuClose} to="/collections">Collections</Link></li>
                                <li><Link onClick={this.menuClose} to="/marketplace">Marketplace</Link></li>
                                <li><Link onClick={this.menuClose} to="/how it works">How it works</Link></li>
                                <li><Link onClick={this.menuClose} to="/blog">Blog</Link></li>
                                <li><Link onClick={this.menuClose} to="/about">About</Link></li>
                                {/*<li><Link onClick={this.menuClose} to="/">D-Game</Link></li>*/}
                                <li><Link onClick={this.menuClose} to='/contact'>Contact</Link></li>
                                <li><Link onClick={this.menuClose} to="/profile">My Account</Link></li>
                            </ul>
                        </div>
                        <div className="mobile-menu-popup-content-footer">
                            <a class="fb-ic menu-social-ic">
                            <a href="https://www.facebook.com/diginoornft/" target="_blank"><i class="fab fa-facebook-f fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                            </a>
                            <a class="tw-ic menu-social-ic">
                            <a href="https://twitter.com/diginoor_NFT" target="_blank"><i class="fab fa-twitter fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                            </a>
                            <a class="gplus-ic menu-social-ic">
                            <a href="https://discord.gg/C2APxt2h4P" target="_blank"><i class="fab fa-discord fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                            </a>
                            <a class="li-ic menu-social-ic">
                            <a href="https://www.linkedin.com/company/diginoor" target="_blank"> <i class="fab fa-linkedin-in fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a>
                            </a>
                            <a class="ins-ic menu-social-ic">
                            <a href="https://www.instagram.com/diginoor.io" target="_blank"><i class="fab fa-instagram fa-lg white-text mr-md-5 mr-3 fa-2x"> </i></a> 
                            </a>
                            <a class="pin-ic menu-social-ic">
                            <a href="https://wa.me/+15714120310" target="_blank"> <i class="fab fa-whatsapp mr-md-5 mr-3 fa-lg white-text fa-2x"> </i></a>
                            </a>
                            <a class="pin-ic menu-social-ic">
                            <a href="https://t.me/+LsXcY48EHCMwMGU1" target="_blank"> <i class="fab fa-telegram mr-md-5 mr-3 fa-lg white-text fa-2x"> </i></a>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Notification Menu */}

                <div className="notification-container">
        <div className="notification-box">
            <div className="notification-box-header">
                <h3>Notifications</h3>
                <button className="notification-close" onClick={this.notificationClose}>x</button>
            </div>
                <div className='notification-list'>
                {this.state.notifications.map(notification => {
                    return(
                    <div id={`${notification._id}`} onClick={() => {this.notificationsRead(notification._id)} } 
                         className={
                             notification.read == false ? `notification-list-item ${notification._id}` : `notification-list-item ${notification._id} notification-item-read`}>
                        <div className='notification-list-item-header'>
                            <div>
                                <p>{notification.text}</p>
                            </div>
                            <div style={{textAlign:"right"}} >
                                <img className="notification-item-im" />
                            </div>
                        </div>
                        <div className="notification-list-item-meta">
                            <p>26th December, 2021</p>
                            <p>few minutes ago</p>
                        </div>
                    </div>
                    )
                })}
                </div>
        </div>
    </div>
            </>
        )
    }
}

export default Mobile_User_Menu;